<template>
	<div class="flex flex_between">
		<md-field>
			<label>{{ $t(labelText) }}</label>
			<TbSelect
				v-model="moduleValue"
				@md-selected="onSelect"
				:search-allow="true"
				:search-debounce="400"
				:search-min-length="2"
				:options="options"
				options-value-field="displayValue"
				options-display-field="displayValue"
				option-disabled-field="disabled"
				:search-custom="true"
				@search="searchCompany"
				:no-entries-text="$t('common.select.searchRequired')"
				:disabled="disabled"
				content-size="xl"
				ref="companySearch"
			/>
		</md-field>
	</div>
</template>
<script>

export default {
	props: {
		labelText: { type: String, default: "common.searchCompany" },
		value: { type: Object, default: null },
		searchFunction: { type: Function, default: null },
		disabled: { type: Boolean, default: false }
	},
	data() {
		return {
			moduleValue: "",
			options: [],
		};
	},
	methods: {
		searchCompany(searchValue) {
			this.searchFunction(searchValue)
				.then(res => {
					this.options = res.map(item => {
						return {
							...item,
							displayValue: item.name + " - " + item.city + (item.taxNum ? " (" + item.taxNum  + ")" : "")
						};
					});
				})
				.catch(this.toast);
		},
		resetCompany() {
			this.moduleValue = "";
			this.options = [];
			this.$refs.companySearch.resetSearch();
			this.$emit("input", null);
		},
		onSelect() {
			this.$emit("input", this.options.find(option => option.displayValue === this.moduleValue));
		},
	}
};
</script>